import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { Toaster } from 'sonner';
import '@/App.css';

import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Cointracker from './pages/Cointracker';
import Email from './pages/Email';
import Numbers from './pages/Numbers';
import VAsManagement from './pages/VAsManagement';
import VADetails from './pages/VADetails';
import LinkMappings from './pages/LinkMappings';
import Invoices from './pages/Invoices';
import Bills from './pages/Bills';
import Payments from './pages/Payments';
import Analytics from './pages/Analytics';
import CupidBot from './pages/CupidBot';
import Generation from './pages/Generation';
import AccountCreation from './pages/AccountCreation';
import Chatting from './pages/Chatting';
import Settings from './pages/Settings';
import VASettings from './pages/VASettings';
import Layout from './components/Layout';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-white">Loading...</div>
      </div>
    );
  }
  
  return user ? children : <Navigate to="/login" />;
};

const AdminRoute = ({ children }) => {
  const { user } = useAuth();
  return user?.role === 'admin' ? children : <Navigate to="/" replace />;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={
              <PrivateRoute>
                <Layout />
              </PrivateRoute>
            }>
              <Route index element={<Dashboard />} />
              <Route path="cointracker" element={<AdminRoute><Cointracker /></AdminRoute>} />
              <Route path="email" element={<Email />} />
              <Route path="numbers" element={<Numbers />} />
              <Route path="vas" element={<VAsManagement />} />
              <Route path="vas/:vaId" element={<VADetails />} />
              <Route path="links" element={<LinkMappings />} />
              <Route path="invoices" element={<Invoices />} />
              <Route path="bills" element={<AdminRoute><Bills /></AdminRoute>} />
              <Route path="payments" element={<Payments />} />
              <Route path="analytics" element={<Analytics />} />
              <Route path="cupidbot" element={<CupidBot />} />
              <Route path="generation" element={<Generation />} />
              <Route path="account-creation" element={<AccountCreation />} />
              <Route path="chatting" element={<AdminRoute><Chatting /></AdminRoute>} />
              <Route path="settings" element={<AdminRoute><Settings /></AdminRoute>} />
              <Route path="va-settings" element={<VASettings />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" theme="dark" />
      </AuthProvider>
    </div>
  );
}

export default App;